<template>
    <Transition>
        <div v-show="isShow" class="dialog">
            <div class="flex aic pt-15 pl-20 pb-15 pr-20 fff">
                <span class="mr-10 f18 fwb">{{ message }}</span>
                <svg t="1687232285520" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    p-id="5489" width="32" height="32">
                    <path d="M523.9 511.98m-419.5 0a419.5 419.5 0 1 0 839 0 419.5 419.5 0 1 0-839 0Z" fill="#FFD629"
                        p-id="5490"></path>
                    <path
                        d="M885.2 298.58c-1.6-0.6 37.1 68.4 49.5 128.9 46.4 227-99.9 448.6-326.9 495.1-37.9 7.8-75.7 10.1-112.5 7.7-63.2-4.2-123.6-22.8-177.3-53 0 0 348.9-269.7 567.2-578.7z"
                        fill="#FF9A2C" opacity=".1" p-id="5491"></path>
                    <path
                        d="M922.4 383.38c73.9 216.8-52.8 456-264 525.8-36.7 12.1-108.5 28.3-184.9 19.4 0-0.5 166.62-15.7 313.54-190.74C942.88 552.16 920.2 376.98 922.4 383.38z"
                        fill="#FF9A2C" opacity=".2" p-id="5492"></path>
                    <path
                        d="M790 184.48c-40.9-34.6-93.6-59.3-155.8-77.3-95.5-27.6-199.4-17.7-300.6 31.5-139.3 67.7-240.1 245.9-227.6 400.2 4.2 52 10.1 101.8 30 145.5 0.5 1 1.6 1.5 2.7 1.2 21.1-6.8 218.8-73.6 375.8-190.3 213.3-158.5 292.3-296.6 275.5-310.8z"
                        fill="#FCE99A" opacity=".24" p-id="5493"></path>
                    <path
                        d="M188.008782 408.574552a136 234.3 54.429 1 0 381.157036-272.589938 136 234.3 54.429 1 0-381.157036 272.589938Z"
                        fill="#F9F2D7" opacity=".2" p-id="5494"></path>
                    <path d="M616.9 326.38m-52.7 0a52.7 52.7 0 1 0 105.4 0 52.7 52.7 0 1 0-105.4 0Z" fill="#211715"
                        p-id="5495">
                    </path>
                    <path
                        d="M381.7 438.38l-77.6 125.3-15.5-8c-16-8.2-22.3-27.9-14.1-43.9l26.2-47.3-45.6-19.6c-15.7-8.1-21.9-27.4-13.8-43.1l8.2-16 132.2 52.6z"
                        fill="#211715" p-id="5496"></path>
                    <path
                        d="M603 479.68c27.4 56.5 14.1 119.5-29.7 140.8s-101.6-7.2-129-63.7l30.6-8c37.4-9.7 72.1-26.6 102.9-50l25.2-19.1z"
                        fill="#F94616" p-id="5497"></path>
                    <path
                        d="M514.5 567.38l8.8 6c3.6 2.5 8.3 2.8 12.2 0.7l26.9-14c3.4-1.8 5.7-5.1 6.3-8.9l1.5-10.5c1.4-10-9.4-17.1-18-11.9-9.1 5.5-20.9 11.8-35.4 17.7-8.8 3.6-10.1 15.5-2.3 20.9z"
                        fill="#E53600" opacity=".68" p-id="5498"></path>
                    <path
                        d="M922.4 383.38c73.9 216.8-52.8 456-264 525.8-36.7 12.1-108.5 28.3-184.9 19.4 0-0.5 122.92-45.83 275.21-216.29C910.21 531.51 920.2 376.98 922.4 383.38z"
                        fill="#FF9A2C" opacity=".19" p-id="5499"></path>
                    <path
                        d="M922.4 383.38c73.9 216.8-52.8 456-264 525.8-36.7 12.1-108.5 28.3-184.9 19.4 0-0.5 89.92-84.69 242.21-255.15C877.21 492.65 920.2 376.98 922.4 383.38z"
                        fill="#FF9A2C" opacity=".15" p-id="5500"></path>
                </svg>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    message: {
        type: String,
        default: ''
    }
})

const isShow = ref(props.show)

let time
watch(() => props.show, (e) => {
    if (e) {
        time = setTimeout(() => {
            isShow.value = false
            clearTimeout(time)
        }, 3000)
    }
}, {
    deep: true,
    immediate: true
})

</script>

<style lang="less" scoped>
.v-enter-active,
.v-leave-active {
    transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

.dialog {
    position: absolute;
    left: 50%;
    top: 6%;
    margin: auto;
    background-color: #4d4d4d;
    border-radius: 5px;
    z-index: 9999;
}
</style>